const { arrivalStationNameForMap, departureStationNameForMap } = searchParameters;
export let arrivalIdx = 0;
export let destinationIdx = 0;

/**
 * @function getCoordinates - Получает координаты станций от пункта отправления до пункта прибытия
 * @param {array} points - список остановочных пунктов
 * @return array
 * */

export default function getCoordinates(points) {
    const coords = [];
    let targetCoordsInclude = false;

    for (let i = 0; i < points.length; i++) {
        const { name, latitude, longitude } = points[i];

        if (departureStationNameForMap === name) {
            targetCoordsInclude = true;
            arrivalIdx = i;
        }

        if (targetCoordsInclude) {
            coords.push([latitude, longitude])

            if (arrivalStationNameForMap === name) {
                destinationIdx = i;
                break;
            }
        }
    }

    return coords;
}
